import type { SupportTicketId } from "@redotech/effect-api-shared/ids/definitions";
import type { Message } from "@redotech/effect-api-shared/models/shopper-ai/conversation/message";
import type { ChannelThread } from "@redotech/effect-api-shared/models/shopper-ai/conversation/thread";
import { memo } from "react";
import { ChatThreadView } from "./chat-thread-view";

interface TiktokThreadViewProps {
  messages: Message[];
  supportTicketId: SupportTicketId;
  thread: ChannelThread;
}

export const TiktokThreadView = memo(function TiktokThreadView({
  messages,
  supportTicketId,
  thread,
}: TiktokThreadViewProps) {
  return (
    <ChatThreadView
      channel="tiktok"
      messages={messages}
      supportTicketId={supportTicketId}
      thread={thread}
    />
  );
});
